var _path, _rect, _rect2, _rect3, _path2, _polygon, _polygon2, _polygon3, _polygon4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Unit50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6c19ff",
    d: "M10,10v28h28V10H10z M34,34H14V14h20V34z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    x: 30,
    y: 6,
    fill: "#3dd9eb"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    x: 6,
    y: 30,
    fill: "#3dd9eb"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    x: 30,
    y: 30,
    fill: "#3dd9eb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f55376",
    d: "M6,6h12v12H6V6z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#eb0000",
    points: "10,18 14,18 14,14 18,14 18,10 10,10"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#00b3d7",
    points: "30,14 34,14 34,18 38,18 38,10 30,10"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#00b3d7",
    points: "38,30 34,30 34,34 30,34 30,38 38,38"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#00b3d7",
    points: "18,34 14,34 14,30 10,30 10,38 18,38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Unit50);
export default __webpack_public_path__ + "static/media/icons8-unit-50.a6acc9acfc1dec37061bf7f4994ab8c1.svg";
export { ForwardRef as ReactComponent };